<template>
  <div class="service-info-main">
    <div class="service-info-title">服务信息</div>
    <!-- <el-card class="usege-package-info info-item" v-if="data.expire_at && data.usage_package">
      <div class="info-title">MCP</div>
      <el-form label-width="auto" label-position="right">
        <el-form-item label="剩余数量:">
          <span>{{ toThousandFilter(data.usage_package) }}</span>
          <el-link class="link-btn" type="primary" @click="goToUsagePackage">购买Token包</el-link>
        </el-form-item>
      </el-form>
    </el-card> -->
    <el-card class="prepaid-info info-item">
      <div class="info-title">订阅详情</div>
      <el-form label-width="auto" label-position="right" v-if="data.expire_at">
        <el-form-item label="有效期:">
          <span>{{ parseTime(data.expire_at) }}</span
          ><span v-if="data.now > data.expire_at">(已过期)</span>
          <el-link class="link-btn" type="primary" @click="goToPrepaid">续费服务</el-link>
        </el-form-item>
        <el-form-item label="本期订阅类型:" v-if="data.prepaid">
          {{ data.prepaid.product_info.product_title }}
        </el-form-item>
        <!-- <el-form-item label="本期剩余数量:" v-if="data.prepaid">
          {{ toThousandFilter(data.prepaid.token_remaining) }}/{{
            toThousandFilter(data.prepaid.product_info.token_num)
          }}
        </el-form-item> -->
      </el-form>
      <div v-else class="tip">
        服务未订阅，<el-link class="link-btn" type="primary" @click="goToPrepaid">开通服务</el-link>
      </div>
    </el-card>
  </div>
</template>
<script setup>
import { onMounted, reactive } from 'vue'
import { getServiceInfo } from '@/api/userService'
import { parseTime, toThousandFilter } from '@/utils'
import { useRouter } from 'vue-router'
const router = useRouter()

const serviceId = 4
const data = reactive({
  now: Math.floor(Date.now() / 1000),
  expire_at: 0,
  prepaid: {
    token_remaining: 0,
    token_original: 0,
    product_info: {
      token_num: 0,
      product_title: '',
    },
  },
  usage_package: 0,
})

onMounted(() => {
  getInfo()
})

function goToPrepaid() {
  router.push({
    name: 'productPrepaidList',
  })
}

function goToUsagePackage() {
  router.push({
    name: 'productUsagePackageList',
  })
}

async function getInfo() {
  let res = await getServiceInfo({
    service_id: serviceId,
  })
  if (res.data.ret == 0) {
    let resData = res.data.data
    data.now = resData.now
    if (resData.prepaid && resData.prepaid.product_info) {
      resData.prepaid.product_info = JSON.parse(resData.prepaid.product_info)
    }
    data.prepaid = resData.prepaid
    data.usage_package = resData.usage_package
    data.expire_at = resData.expire_at
  }
}
</script>
<style lang="scss" scoped>
.link-btn {
  margin-left: 8px;
}
.tip {
  display: flex;

  .link-btn {
    margin-left: 0;
  }
}
</style>
